var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"v-app","dark":_vm.appConfig.dark}},[_c('BaseToolbar'),_c('SidebarBasic'),_c('v-main',{staticClass:"v-content__wrap"},[_c('vue-page-transition',{staticClass:"pa-5",attrs:{"name":"fade-in-down"}},[_c('router-view')],1),_c('BaseFooter')],1),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }